import { BaseReader } from "../base-reader";
import { TierInfoRequestArgs, TierInfoSchema } from "./tier.types";

export class TierReader extends BaseReader {
  /**
   * Get tier info for an owner based on percentile-based thresholds
   * @param ownerAddr The owner address to get tier info for
   * @returns Tier info with progress toward each tier
   */
  async getByOwner({ ownerAddr, fetchOptions }: TierInfoRequestArgs) {
    const queryParams = new URLSearchParams({ owner: ownerAddr });

    const response = await this.getRequest({
      schema: TierInfoSchema,
      url: `${this.deps.config.tradingHttpUrl}/api/v1/points/tier`,
      queryParams,
      options: fetchOptions,
    });

    return response.data;
  }
}
